import { Form, Formik } from "formik";
import { AccordionRoot } from "../Accordion";
import ShareUrl from "../Share";
import FormMainContent from "../layouts/FormMainContent";
import { getTexts } from "./texts";
import {
  TilsynserklaeringFormValues,
  TilsynserklaeringMetadata,
} from "../../interfaces/tilsynserklaering";
import TilsynerklaeringSection1 from "./sections/TilsynerklaeringSection1";
import TilsynerklaeringSection2 from "./sections/TilsynerklaeringSection2";
import TilsynerklaeringSection3 from "./sections/TilsynerklaeringSection3";
import TilsynerklaeringSection4 from "./sections/TilsynerklaeringSection4";
import { TILSYN_FORM_VALIDATION_SCHEMA } from "../../constants/tilsyn/validationSchemas";
import TESidebar from "./TESidebar";

export default function TilsynserklaeringForm({
  id,
  initialValues,
  metaData,
  loginToken,
}: {
  id: string;
  initialValues: TilsynserklaeringFormValues;
  metaData: TilsynserklaeringMetadata;
  loginToken: string;
}) {
  return (
    <>
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={initialValues}
        validationSchema={TILSYN_FORM_VALIDATION_SCHEMA}
        onSubmit={() => {}}
      >
        {(props) => {
          const { values } = props;
          const texts = getTexts(values, metaData);

          return (
            <Form className="card mt-6">
              <div className="bg-white row g-0 border-bottom">
                <div className="card-header col-9 border-0">
                  <h2 className="display-2">{texts.formTitle}</h2>
                </div>
                <div className="col-3 px-4 pt-6">
                  <ShareUrl
                    heading="Invitér en anden til at udfylde erklæringen"
                    text="Kopiér linket og send det til en anden, for at give vedkommende adgang til at redigere denne erklæring. Erklæringen skal efterfølgende godkendes med MitID af dig som advokat."
                    loginToken={loginToken}
                    type="TE"
                  />
                </div>
              </div>
              <div className="card-body p-0">
                <div className="row g-0">
                  <FormMainContent>
                    <AccordionRoot defaultValue={["1"]}>
                      <TilsynerklaeringSection1 props={props} texts={texts} />
                      <TilsynerklaeringSection2 props={props} texts={texts} />
                      <TilsynerklaeringSection3 props={props} texts={texts} />
                      <TilsynerklaeringSection4 props={props} texts={texts} />
                    </AccordionRoot>
                  </FormMainContent>
                  <TESidebar
                    formik={props}
                    texts={texts}
                    id={id}
                    metaData={metaData}
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
